import difference from 'lodash/difference';

import userRoles from '../shared/authorization/userRoles';
import { getNormalizedKeyName } from '../utils/readXlsxFile.utils';

const MANAGMENT_ENTITY = 'managemententity';

const getNormalizedColumnNames = worksheet => {
  const headers = [];
  const firstRow = worksheet.getRow(1);

  for (let colNum = 1; colNum <= worksheet.columnCount; colNum++) {
    const cell = firstRow.getCell(colNum);
    if (cell.value) {
      const cellText = cell.text || String(cell.value);
      headers.push(getNormalizedKeyName(cellText));
    }
  }

  return headers;
};

const getColumnValues = (worksheet, colNum, skipFirstRow = true) => {
  const values = [];
  const startRow = skipFirstRow ? 2 : 1;

  for (let rowNum = startRow; rowNum <= worksheet.rowCount; rowNum++) {
    const cell = worksheet.getRow(rowNum).getCell(colNum);
    if (cell.value) {
      const cellText = (cell.text || String(cell.value)).trim();
      if (!values.includes(cellText)) {
        values.push(cellText);
      }
    }
  }

  return values;
};

const getNonEsCompanyCodes = worksheet => {
  const values = [];

  for (let rowNum = 2; rowNum <= worksheet.rowCount; rowNum++) {
    const row = worksheet.getRow(rowNum);
    const managementEntity = row.getCell(2); // Column B
    const legalEntity = row.getCell(3); // Column C

    if (managementEntity.value && legalEntity.value) {
      const managementText = (managementEntity.text || String(managementEntity.value)).trim();
      const legalText = (legalEntity.text || String(legalEntity.value)).trim();
      const companyCode = `${legalText}_${managementText}`;

      if (!values.includes(companyCode)) {
        values.push(companyCode);
      }
    }
  }

  return values;
};

const checkIfIsNonEs = columnName => columnName[1] === MANAGMENT_ENTITY;

export const validateColumnHeaders = (workbook, mappedFieldNames) => {
  const worksheet = workbook.worksheets[0];

  const normalizedColumnNames = getNormalizedColumnNames(worksheet);

  const missingColumns = difference(mappedFieldNames, normalizedColumnNames);
  const extraColumns = difference(normalizedColumnNames, mappedFieldNames);

  if (missingColumns.length > 1 || extraColumns.length) {
    return -1;
  }

  const missingColumn = mappedFieldNames.findIndex(fieldName => fieldName === missingColumns[0]);

  return missingColumn !== -1
    ? missingColumn + 1
    : 0;
};

export const validatePeriods = (workbook, validationData) => {
  const worksheet = workbook.worksheets[0];
  const { userRole, period, currentPeriod } = validationData;

  const periodToCompare = userRole === userRoles.SUPER_USER
    ? period
    : currentPeriod;

  const periodValues = getColumnValues(worksheet, 1); // Column A

  const allPeriodsValid = periodValues.every(period => period === periodToCompare.name);

  return allPeriodsValid;
};

export const validateCompanyCodes = (workbook, validationData) => {
  const worksheet = workbook.worksheets[0];
  const { companyCodes } = validationData;

  const normalizedColumnNames = getNormalizedColumnNames(worksheet);

  const isNonEs = checkIfIsNonEs(normalizedColumnNames);

  const companyCodesToValidate = isNonEs
    ? getNonEsCompanyCodes(worksheet)
    : getColumnValues(worksheet, 2); // Column B
  const allCompanyCodes = companyCodes.map(companyCode => companyCode.value);

  return difference(companyCodesToValidate, allCompanyCodes).length === 0;
};
